import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const store = new Vuex.Store({
    //存放状态
    state: {
        selectedKeys: [], // 当前选中的菜单
        cMenuOpenKey: [],  // 当前展开的菜单
    },
    //state成员操作
    mutations: {
        setSelectedKeys(state, payload) {
            state.selectedKeys = payload;
        },
        setCMenuOpenKey(state, payload) {
            state.cMenuOpenKey = payload;
        },
    },
    //加工state成员给外界
    getters: {
    },

    //模块化状态管理
    modules: {

    }
})

export default store


// WEBPACK FOOTER //
// ./src/store/store.js